import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinIssueConvertRoute: InvariantJiraRoute = {
	name: 'legacy-gin-issue-convert',
	path: '/secure/ConvertIssue(\\w*)([!%]?[\\w]*).jspa',
};
